import { enUS as en } from "date-fns/locale"; //add more languages if needed;
const dateLocales = [en];

export { default as i18n } from "./i18n";
export { dateLocales };
